//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;

autoplayManager.containerName = "autoplayContainer:autoplayBackground";

Loader.initialise = function (container) {
  Loader.container = container;

  // Change jackpot to pot in some regions
  Loader.doTranslationPhrases();

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler("ready", Loader.onLayoutComplete);
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === "loading") {
    globalThis.__PIXI_STAGE__ = systemData.stage;
    globalThis.__PIXI_RENDERER__ = systemData.renderer;
    Loader.progressBar = resourceManager.get("loader:loadingProgressBack");
    Loader.setLoadProgress(0);
    resourceManager.getContainer("loadingContainer").visible = true;
    resourceManager.getContainer("backgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("darkOverlayContainer").visible = true;

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get("GamCareContainerPreLoad:gamCareLogo").visible = isGamCareLogoVisible;
    resourceManager
      .get("GamCareContainerPreLoad:preLoadMessage")
      .setText(isPreloadMessageVisible ? loadingData.message : "");
    resourceManager.get("GamCareContainerPreLoad").visible =
      isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== "loading") {
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  // gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  // gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  // gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  // gameData.winningsMeterTitle = resourceManager.get(
  //   "meterContainer:winnings:title"
  // );
  gameData.screenDim = resourceManager.get("backgroundScreenDimObject");
  //messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);

  // loading bar finished - hide now whilst waiting for player to continue
  // resourceManager.get( "loader:loadingBarBack" ).visible = false;
  // resourceManager.get( "loader:loadingBarFrame" ).visible = false;
  // resourceManager.get( "loader:loadingProgressBack" ).visible = false;
  // resourceManager.get( "loader:loadingText" ).visible = false;
};

// We need to replace JACKPOT with POT in some regions
Loader.doTranslationPhrases = function () {
  if (gameController.license === "" || gameController.license === undefined) {
    gameController.license = "default";
  }

  const license = gameController.license.toUpperCase();

  if (license === "DE" || license === "LT" || license === "FIN") {
    gdk.addConfigValue("t_jackpotCoin", "t_jackpotCoin_Pot");
    gdk.addConfigValue("t_collectInfo4", "t_collectInfo4_Pot");
    gdk.addConfigValue("t_collectInfoMega", "t_collectInfoMega_Pot");
    gdk.addConfigValue("t_collectInfoMajor", "t_collectInfoMajor_Pot");
    gdk.addConfigValue("t_collectInfoMinor", "t_collectInfoMinor_Pot");
    gdk.addConfigValue("t_collectInfoMini", "t_collectInfoMini_Pot");
    gdk.addConfigValue("t_jackpotReelTitle", "t_jackpotReelTitle_Pot");
    gdk.addConfigValue("t_jackpotInfo1", "t_jackpotInfo1_Pot");
    gdk.addConfigValue("t_jackpotInfo2", "t_jackpotInfo2_Pot");
    gdk.addConfigValue("t_labelCollectForJackpotSpin", "t_labelCollectForJackpotSpin_Pot");
  } else {
    gdk.addConfigValue("t_jackpotCoin", "t_jackpotCoin");
    gdk.addConfigValue("t_collectInfo4", "t_collectInfo4");
    gdk.addConfigValue("t_collectInfoMega", "t_collectInfoMega");
    gdk.addConfigValue("t_collectInfoMajor", "t_collectInfoMajor");
    gdk.addConfigValue("t_collectInfoMinor", "t_collectInfoMinor");
    gdk.addConfigValue("t_collectInfoMini", "t_collectInfoMini");
    gdk.addConfigValue("t_jackpotReelTitle", "t_jackpotReelTitle");
    gdk.addConfigValue("t_jackpotInfo1", "t_jackpotInfo1");
    gdk.addConfigValue("t_jackpotInfo2", "t_jackpotInfo2");
    gdk.addConfigValue("t_labelCollectForJackpotSpin", "t_labelCollectForJackpotSpin");
  }

  const currentLanguage = gdk.getCurrentLanguage();
  if (currentLanguage === "en-GB") {
    gdk.addConfigValue("fontReplacementLoading_Green", "loadingFontEnGreen");
    gdk.addConfigValue("fontReplacementLoading_Yellow", "loadingFontEnYellow");
    gdk.addConfigValue("fontReplacementLoading_Orange", "loadingFontEnOrange");
    gdk.addConfigValue("fontReplacementLoading_gbDescText", "gbDescText");
  } else {
    gdk.addConfigValue("fontReplacementLoading_Green", "loadingFontNonEnGreen");
    gdk.addConfigValue("fontReplacementLoading_Yellow", "loadingFontNonEnYellow");
    gdk.addConfigValue("fontReplacementLoading_Orange", "loadingFontNonEnOrange");
    gdk.addConfigValue("fontReplacementLoading_gbDescText", "gbNonEnDescText");
  }
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];

  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController("inputOverlord");
  gameData.inputOverlord.setState("disabled");
  gameData.slotConfig = gameConfigTask.data.slotConfig;
  gameData.LastGameMode = gameConfigTask.data.slotConfig.LastGameMode;

  gameData.maxExposure = gameConfigTask.data.maxExposure;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (element) {
      return element.name === "encore";
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager.getController("stakeController").setStakeMultiplier(encoreData.value);
    game.changeStake(resourceManager.getController("stakeController").CurrentStake);
    game.resetWinnings();
    resourceManager.getController("stakeController").broadcastCurrentStake();
  }

  // Allow player to click through load screen
  // let backgroundLandscape = resourceManager.get('splashBackgroundL');
  // backgroundLandscape.setInteractiveCallbacks(function () {
  //   backgroundLandscape.interactive = false;
  //   gdk.loadingClosed();
  //   Reflex.updateViewport();
  // }, true);

  // let backgroundPortrait = resourceManager.get('splashBackgroundP');
  // backgroundPortrait.setInteractiveCallbacks(function () {
  //   backgroundPortrait.interactive = false;
  //   gdk.loadingClosed();
  //   Reflex.updateViewport();
  // }, true);

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  game.stopDistances = gameConfigTask.data.stopDistances;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  Loader.setStartingSymbols();

  var slotMachine = resourceManager.getController("SlotMachine");

  // All objects are created, so create game specific data
  for (var i = 0; i < slotMachine.reels.length; i++) {
    let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
    let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

    // Copy starting symbols from server
    for (var j = 0; j < reelLength; ++j) {
      reel.setReelSymbol(j, startingSymbols[j].value);
    }

    gameData.reels.push(reel);
  }

  Loader.readyForSplash = true;

  Loader.checkCanGoToSplash();
};

Loader.setStartingWinWaysCounterValue = function () {
  let reel0Size = gameData.slotConfig.startingSymbols[0].symbols.length;
  let reel1Size = gameData.slotConfig.startingSymbols[1].symbols.length;
  let reel2Size = gameData.slotConfig.startingSymbols[2].symbols.length;
  let reel3Size = gameData.slotConfig.startingSymbols[3].symbols.length;
  let reel4Size = gameData.slotConfig.startingSymbols[4].symbols.length;

  gameController.desktopWinWaysCounter.setText(reel0Size * reel1Size * reel2Size * reel3Size * reel4Size);
};

Loader.setStartingSymbols = function () {
  for (var i = 0; i < 5; i++) {
    var reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    var startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;

    const reelVisual = resourceManager.get("slotContainer:reelContainer:reel" + i);
    reelVisual.resetAllSymbolData();

    reelVisual.setAppertureHeight(5);
    Loader.setStartingWinWaysCounterValue();

    var symbol;
    for (let j = 0; j < startingSymbols.length; ++j) {
      if (startingSymbols[j] !== undefined) {
        symbol = startingSymbols[j].value;
        reel.setReelSymbol(j, symbol);
      }
    }
    reelVisual._reelSpinnerData.resetSymbolPositions();
  }
};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;

    Loader.progressBar.scale.x = 0.975;

    resourceManager.getContainer("loadingContainer").visible = false;
    game.goToSplash();

    // timerManager.addTimer(0, undefined, function () {
    //   resourceManager.getContainer("loadingContainer").visible = false;
    // });
  }
};

Loader.setLoadProgress = function (percent) {
  var width = Loader.progressBar.texture.baseTexture.width * percent;
  Loader.progressBar.texture.frame = new PIXI.Rectangle(0, 0, width, Loader.progressBar.texture.baseTexture.height);
};

messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);
